// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2zT9U","inputDescription":"styles_inputDescription__1UnND"};